module.exports = __webpack_public_path__ + "static/media/ubi.770122af.png";